<template>
  <v-app  :dark="isDark" id="app">
    <v-content
      class="main" 
      fluid> 
      <v-layout>
        <v-flex xs1> 
            <v-menu v-if="auth"/>
        </v-flex>
      </v-layout>
      <router-view/>
      <!-- <terminalSnackbar/> -->
     <!--  <v-footer/>

 -->    </v-content>
  </v-app>
</template>

<script>
  import Vue from 'vue'
  import Menu from '@/components/Menu.vue'
  import Footer from '@/components/Footer.vue'
  import Sidebar from '@/components/Sidebar'
  import terminalSnackbar from '@/components/util/terminalSnackbar'
  import { mapState } from 'vuex'
  import store from "@/store"

  Vue.component('v-menu', Menu)
  Vue.component('v-footer', Footer)
  Vue.component('v-sidebar', Sidebar)

  const eventHub = new Vue();

  import 'vuetify/dist/vuetify.min.css'


  export default {
    name: 'App',
    components: {
      terminalSnackbar
    },
    computed: {
        ...mapState({
            isDark: state => state.util.isDark,
        })
    },
    created: function () {
     
    },
    data: function () {
      return {
        auth: false
      }
    }
  }
</script>

<style>
@import '~bootstrap/dist/css/bootstrap.css';
@import '~bootstrap-vue/dist/bootstrap-vue.css';

/* fallback */
@font-face {
  font-family: 'Material Icons';
  font-style: normal;
  font-weight: 400;
  src: url(https://fonts.gstatic.com/s/materialicons/v47/flUhRq6tzZclQEJ-Vdg-IuiaDsNc.woff2) format('woff2');
}

.material-icons {
  font-family: 'Material Icons';
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-feature-settings: 'liga';
  -webkit-font-smoothing: antialiased;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  padding: 0;
}

.main{
  margin: 0;
  padding: 0;
}

.fa-icon {
    top: .125em;
    position: relative;
}

.b-main-content {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  margin-right: 0;
  margin-left: 0;
}

.b-form-1 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  margin-right: 0;
  margin-left: 0;
  border-width: .2rem;
}

.color-change-3x {
  -webkit-animation: color-change-3x 4s linear infinite alternate both;
          animation: color-change-3x 4s linear infinite alternate both;
}
/*distracting???*/
/*@-webkit-keyframes color-change-3x {
  0% {
    background: rgba(0,0,0,0.01);
  }
  50% {
    background: rgba(0,0,0,0.1);
  }
  100% {
    background: rgba(0,0,0,0.01);
  }
}
@keyframes color-change-3x {
  0% {
    background: rgba(0,0,0,0.01);
  }
  50% {
    background: rgba(0,0,0,0.1);
  }
  100% {
    background: rgba(0,0,0,0.01);
  }
}
*/
</style>
